document.addEventListener('DOMContentLoaded', () => {
    const tilesWrapper = document.querySelector('.hover-tiles-grid');
    const tiles = document.querySelectorAll('.hover-tile-unit-wrapper');
    const loadMoreBtn = document.querySelector('.hover-tiles .load-more-link');
    const numberTilesDesktop = tilesWrapper.getAttribute('data-desktop-count');
    const numberTilesMobile = tilesWrapper.getAttribute('data-mobile-count');
    const numberTiles = (window.innerWidth > 768) ? numberTilesDesktop : numberTilesMobile;
    let isOpened = false;

    if (tiles.length <= numberTiles) loadMoreBtn.classList.add('hide');

    hideShowTiles ();

    loadMoreBtn.addEventListener('click', () => {
        isOpened = !isOpened;
        hideShowTiles ();
        loadMoreBtn.innerHTML = isOpened ? 'Less' : 'Load More';
    })

    function hideShowTiles () {
        tiles.forEach((tile, index) => {
            if (index > numberTiles - 1) {
                if (!isOpened) tile.classList.add('hide');
                if (isOpened) tile.classList.remove('hide');
            }
        })
    }
})